export const ADROYALTIES_ELEMENTS_APPEARANCE = {
  theme: {
    appearance: "dark",
    accentColor: "grass",
    grayColor: "gray",
    dangerColor: "red",
    warningColor: "amber",
    successColor: "grass",
    infoColor: "sky",
  },
  variables: {
    "--radius": "10px",
    "--color-background": "#09090b",
    "--color-panel-solid": "#101014",
    "--color-panel-translucent": "rgba(16, 16, 20, 0.9)",
    "--color-stroke": "rgba(255, 255, 255, 0.14)",
    "--default-font-family": 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--heading-font-family": 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--strong-font-family": 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    "--default-letter-spacing": "-0.01em",
    "--heading-letter-spacing": "-0.035em",
    "--table-row-background-color": "transparent",
    "--accent-1": "#0b140e",
    "--accent-2": "#0f1a13",
    "--accent-3": "#12271a",
    "--accent-4": "#143120",
    "--accent-5": "#173b27",
    "--accent-6": "#1c4832",
    "--accent-7": "#235c40",
    "--accent-8": "#2c7c54",
    "--accent-9": "#54e88f",
    "--accent-10": "#6bef9d",
    "--accent-11": "#7defab",
    "--accent-12": "#c9f9dd",
    "--accent-9-contrast": "#09090b",
    "--gray-1": "#09090b",
    "--gray-2": "#101014",
    "--gray-3": "#16161c",
    "--gray-4": "#1c1c23",
    "--gray-5": "#22222a",
    "--gray-6": "#2a2a33",
    "--gray-7": "#35353f",
    "--gray-8": "#45454f",
    "--gray-9": "#6b7280",
    "--gray-10": "#7b8290",
    "--gray-11": "#9ca3af",
    "--gray-12": "#fafafa",
    "--orange-9": "#f2c14e",
    "--orange-10": "#e6b23a",
    "--orange-11": "#f2c14e",
    "--orange-12": "#f7dca0",
    "--amber-1": "#12100a",
    "--amber-2": "#17140c",
    "--amber-3": "#1f1a10",
    "--amber-4": "#282012",
    "--amber-5": "#332a17",
    "--amber-6": "#41361f",
    "--amber-7": "#54462a",
    "--amber-8": "#6f5c39",
    "--amber-9": "#f2c14e",
    "--amber-10": "#e6b23a",
    "--amber-11": "#f2c14e",
    "--amber-12": "#f7dca0",
    "--amber-a2": "rgba(255, 255, 255, 0.03)",
    "--amber-surface": "rgba(242, 193, 78, 0.06)",
    "--amber-9-contrast": "#09090b",
    "--yellow-1": "#12100a",
    "--yellow-2": "#17140c",
    "--yellow-3": "#1f1a10",
    "--yellow-4": "#282012",
    "--yellow-5": "#332a17",
    "--yellow-6": "#41361f",
    "--yellow-7": "#54462a",
    "--yellow-8": "#6f5c39",
    "--yellow-9": "#f2c14e",
    "--yellow-10": "#e6b23a",
    "--yellow-11": "#f2c14e",
    "--yellow-12": "#f7dca0",
    "--yellow-a2": "rgba(255, 255, 255, 0.03)",
    "--yellow-surface": "rgba(242, 193, 78, 0.06)",
    "--yellow-9-contrast": "#09090b",
  },
  classes: {
    "whop-FieldLabel": { fontSize: "15px", fontWeight: "650" },
    "whop-FieldDescription": { fontSize: "13px", lineHeight: "1.5" },
    "whop-InputRoot": { minHeight: "48px", borderRadius: "10px" },
    "whop-Input": { padding: "12px 14px", fontSize: "15px" },
    "whop-SelectTrigger": { minHeight: "48px", padding: "10px 14px", borderRadius: "10px", fontSize: "15px" },
    "whop-SelectPopup": { borderRadius: "10px" },
    "whop-DialogContent": { borderRadius: "18px" },
    "whop-DialogHeader": { padding: "20px 22px" },
    "whop-DialogBody": { padding: "20px 22px" },
    "whop-DialogFooter": { padding: "16px 22px 20px" },
  },
};
